import React from 'react';
import AttendeesCartContainer from '../../../Containers/UserContainer/AttendeesCart';

const AttendeesCartScreen = () => {
  return <AttendeesCartContainer />;
};

export default AttendeesCartScreen;
